import {
  request
} from '@/utils/request.js'

const getFilesList = (data, callback, errCallback, finCallback) => {
  request({
    url: '/upload/files',
    method: 'GET',
    params: data,
    noToken: true,
    success: callback,
    fail: errCallback,
    complete: finCallback
  })
}

export {
  getFilesList
}


// WEBPACK FOOTER //
// ./src/servers/filesDownload.js